import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import queryString from 'query-string';

export default function setPaymentInstruction(params) {
    const {
        baseUrl,
        brandId,
        country,
        paymentInstruction,
        clearExisting = 'true',
        uberToken,
        clientId,
        clientSecret,
        clearMessages = true,
        langId,
        additionalHeaders = {},
        ...rest
    } = params;

    invariant(baseUrl, 'baseUrl is a required param of setPaymentInstruction()');
    invariant(brandId, 'brand is a required param of setPaymentInstruction()');
    invariant(country, 'country is a required param of setPaymentInstruction()');
    invariant(paymentInstruction, 'paymentInstruction is a required param of setPaymentInstruction()');
    invariant(uberToken, 'uberToken is a required param of setPaymentInstruction()');
    invariant(clientId, 'clientId is a required param of setPaymentInstruction()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const query = queryString.stringify({ clearMessages, langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self/payment_instruction?${query}`;
    const body = JSON.stringify({ paymentInstruction, clearExisting, ...rest });

    return labelRequest(
        authenticatedRequest(
            new Request(url, { headers: new Headers(headers), method: clearExisting === 'true' ? 'POST' : 'PUT', body }),
            uberToken,
            clientId,
            clientSecret,
        ),
        'setPaymentInstruction',
    );
}
